import React,{useState} from 'react';
import moment from "moment";
import {KoTitle, KoCharts,KoFlex,KoEmpty} from 'packages';
import styles from './sheetDashboard.module.scss';
export default function SheetDashboard({weeklyTotalHours}) {

  const [splitData,setSplitData]    = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);

  // GENERATE WEEK
  const generateWeeks = (startDate, endDate) => {
    const weeks = [];
    let currentWeekStart = startDate.clone().startOf("week");
    
    while (currentWeekStart.isBefore(endDate)) {
      const weekEnd = currentWeekStart.clone().endOf("week");
      weeks.push({
        start: currentWeekStart.format("YYYY-MM-DD"),
        end: weekEnd.format("YYYY-MM-DD"),
        label: `${currentWeekStart.format("MMM D")} - ${weekEnd.format("MMM D, YYYY")}`
      });
      currentWeekStart.add(1, "week");
    }
    return weeks;
  };

  const convertMinutesToHHMM =(minutes)=>{
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    return `${hours}.${remainingMinutes < 10 ? '0' : ''}${remainingMinutes}`;
  };

  const billableMinutes    = [];
  const nonBillableMinutes = [];
  const dateRanges         = [];
  const totalHours         = [];
  if(weeklyTotalHours?.logs && weeklyTotalHours?.logs.length > 0){
    weeklyTotalHours?.logs.forEach(entry => {
      billableMinutes.push(convertMinutesToHHMM(entry.totalBillableMinutes));
      nonBillableMinutes.push(convertMinutesToHHMM(entry.totalNonBillableMinutes));
      let getWeek = generateWeeks(moment(entry.startDate).clone().subtract(0, "weeks"),moment(entry.endDate).clone().subtract(0, "weeks"));
      dateRanges.push(getWeek[0].label);
      let totalHoursInfo = convertMinutesToHHMM(entry.totalMinutes);
      totalHours.push(totalHoursInfo);
    });
  }

  const WORKING_HOURS = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['Billable', 'Non Billable','Total Hours']
    },
    grid: {
      left: 0,
      right: 0,
      bottom: '2%',
      containLabel: true
    },
    xAxis:
      {
        type: 'category',
        data: dateRanges,
        axisTick: { show: false },
        axisLine: { alignWithLabel: true }
      },
    yAxis:{
      type: 'value',
      axisLabel: {
        formatter: function(value) {
          return value > 1 ?  value + ' hrs' : value + 'hr';
        }
      },
      min:0
    }
    ,
    series: [
      {
        name: 'Billable',
        type: 'bar',
        itemStyle:{
          emphasis:{
            barBorderRadius:[9, 9]
          },
          normal: {
            barBorderRadius:[9, 9, 0 ,0 ]
          }
        },
        barWidth: billableMinutes.length > 2 ?  "30%" : "10%",
        emphasis: {
          focus: 'series'
        },
        tooltip: {
          valueFormatter: function(value){
            return value + ' hrs';
          }
        },
        data: billableMinutes
      },
      {
        name: 'Non Billable',
        type: 'bar',
        stack: 'Total',
        itemStyle:{
          emphasis:{
            barBorderRadius:[9, 9]
          },
          normal: {
            barBorderRadius:[9, 9, 0 ,0 ]
          }
        },
        barWidth: nonBillableMinutes.length > 2 ?  "30%" : "10%",
        emphasis: {
          focus: 'series'
        },
        tooltip: {
          valueFormatter: function(value){
            return value + ' hrs';
          }
        },
        data: nonBillableMinutes
      },
      {
        name: 'Total Hours',
        type: 'line',
          // smooth: true,
        yAxisIndex: 0,
        label: {
          show: true,
          valueFormatter: function(value){
            return value + ' hrs';
          },
          position: 'top'
        },
        tooltip: {
          valueFormatter: function(value){
            return value + 'hrs';
          }
        },
        data:totalHours
      }
    ]
  };

  const onBarChartClick = (params) => {
    if (params.componentType === "series" && params.seriesType === "bar") {
      setSelectedCategory(params.name);
      const result = formatLogs(weeklyTotalHours);
      setSplitData(result);
    }
  };

  const workspaceBillableData    = [];
  const workspaceNonBillableData = [];
  const workspaceLabel           = [];
  const dayBillableData          = [];
  const dayNonBillableData       = [];
  const dayspaceLabel            = [];
  const formatLogs = (data) => {
    const formattedData = { byWorkspace: {}, byDay: {} };
    if(data?.logs && data?.logs.length > 0){
      data?.logs.forEach((log) => {
        let getWeek = generateWeeks(moment(log.startDate).clone().subtract(0, "weeks"),moment(log.endDate).clone().subtract(0, "weeks"));
        
        log.byWorkspace.forEach((workspace)=>{
          workspaceBillableData.push(workspace.totalBillableMinutes);
          workspaceNonBillableData.push(workspace.totalNonBillableMinutes);
          workspaceLabel.push(workspace.name);
        });
       
        // Format byWorkspace
        formattedData.byWorkspace[getWeek[0].label] = log.byWorkspace.flatMap((workspace) => [
          {
            value: workspace.totalMinutes,
            name:workspace.name,
            billableHours:workspace.totalBillableWorkHours,
            nonBillableHours:workspace.totalNonBillableWorkHours,
            billableMinutes : workspaceBillableData,
            nonbillableMinutes : workspaceNonBillableData,
            label : workspaceLabel
          }
        ]);
        log.byDay.forEach((day)=>{
          dayBillableData.push(day.totalBillableMinutes);
          dayNonBillableData.push(day.totalNonBillableMinutes);
          dayspaceLabel.push(moment(day.date).format("DD-MMM-YYYY"));
        });
        
        
        // Format byDay
        formattedData.byDay[getWeek[0].label] = log.byDay.flatMap((day) => [
          {
            value: day.totalMinutes,
            name: moment(day.date).format("DD-MMM-YYYY"),
            billableHours:day.totalBillableWorkHours,
            nonBillableHours:day.totalNonBillableWorkHours,
            billableMinutes : dayBillableData,
            nonbillableMinutes : dayNonBillableData,
            label : dayspaceLabel
          }
        ]);
      });
        
      return formattedData;
    }
  };

  const getPieChartOption = () => ({
    title: {
      text: selectedCategory
        ? `${selectedCategory} Breakdown - Workspace`
        : "No data",
      left: "0",
      top: "2%",
      textStyle:{
        fontSize:14
      }
    },
    tooltip: {
      trigger: 'item',
      borderWidth:0,
      formatter: function(params) {
        const emp = splitData.byWorkspace[selectedCategory].find((e) => e.name === params?.name);
        if (!emp) return "";
        return `
            <div style="padding: 10px; border-radius: 5px;border:0px">
              <div style="display: flex; align-items: center; margin-bottom: 8px;">
                <img src="${weeklyTotalHours?.profile.logo[0].url}" alt="avatar" style="width: 40px; height: 40px; border-radius: 50%; margin-right: 10px;" />
                <div>
                  <strong>${weeklyTotalHours?.profile.firstName} ${weeklyTotalHours?.profile.lastName}</strong><br/>
                  <span style="color: gray;">${weeklyTotalHours?.profile.email}</span>
                </div>
              </div>
              <div>
                <strong>Billable:</strong> ${splitData.byWorkspace[selectedCategory][0]['billableHours'] || 0}<br/>
                <strong>Non-Billable:</strong> ${splitData.byWorkspace[selectedCategory][0]['nonBillableHours'] || 0}
              </div>
            </div>
          `;
      }
    },
    xAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        data: selectedCategory ? splitData.byWorkspace[selectedCategory][0]['label'] : []
      }
    ],
    yAxis: {
      type: 'value',
      min:0
    },
    // series: [
    //   {
    //     name: "Pie Chart",
    //     type: "pie",
    //     radius: "50%",
    //     center: ["50%", "50%"],
    //     data: selectedCategory ? splitData.byWorkspace[selectedCategory] : [],
    //     tooltip: { trigger: "item" }
    //   }
    // ]
    series: [
      {
        name: 'Billable',
        type: 'bar',
        barGap: 0,
        barWidth:20,
        emphasis: {
          focus: 'series'
        },
        data: selectedCategory ? splitData.byWorkspace[selectedCategory][0]['billableMinutes'] : []
      },
      {
        name: 'Non Billable',
        type: 'bar',
        barWidth:20,
        emphasis: {
          focus: 'series'
        },
        data: selectedCategory ? splitData.byWorkspace[selectedCategory][0]['nonbillableMinutes'] : []
      }
    ]
  });
  
  const getPieChartDayOption = () => ({
    title: {
      text: selectedCategory
        ? `${selectedCategory} Spending Time By Day`
        : "No data",
      left: "0",
      top: "2%",
      textStyle:{
        fontSize:14
      }
    },
    tooltip: {
      trigger: 'item',
      borderWidth:0,
      formatter: function(params) {
        const emp = splitData.byDay[selectedCategory].find((e) => e.name === params?.name);
        if (!emp) return "";
        return `
            <div style="padding: 10px; border-radius: 5px;border:0px">
              <div style="display: flex; align-items: center; margin-bottom: 8px;">
                <img src="${weeklyTotalHours?.profile.logo[0].url}" alt="avatar" style="width: 40px; height: 40px; border-radius: 50%; margin-right: 10px;" />
                <div>
                  <strong>${weeklyTotalHours?.profile.firstName} ${weeklyTotalHours?.profile.lastName}</strong><br/>
                  <span style="color: gray;">${weeklyTotalHours?.profile.email}</span>
                </div>
              </div>
              <div>
                <strong>Billable:</strong> ${splitData.byDay[selectedCategory][0]['billableHours'] || 0}<br/>
                <strong>Non-Billable:</strong> ${splitData.byDay[selectedCategory][0]['nonBillableHours'] || 0}
              </div>
            </div>
          `;
      }
    },

    xAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        data: selectedCategory ? splitData.byDay[selectedCategory][0]['label'] : []
      }
    ],
    yAxis:{
      type: 'value',
      min:0
    },
    series: [
      {
        name: 'Billable',
        type: 'bar',
        barGap: 0,
        barWidth:20,
        emphasis: {
          focus: 'series'
        },
        data: selectedCategory ? splitData.byDay[selectedCategory][0]['billableMinutes'] : []
      },
      {
        name: 'Non Billable',
        type: 'bar',
        barWidth:20,
        emphasis: {
          focus: 'series'
        },
        data: selectedCategory ? splitData.byDay[selectedCategory][0]['nonbillableMinutes'] : []
      }
    ]
  });

  return (
    <div className={`${styles.wrapper}`}>
      <div className={`${styles.timeSheetPart}`}>
        <div className={styles.modalSubHeader}>
          <KoTitle text='Timesheet Hours' level={5} />
        </div>
        {weeklyTotalHours?.logs && weeklyTotalHours?.logs.length > 0 ?
          <div className={styles.projectChart}>
            <KoCharts
              option={WORKING_HOURS}
              events={onBarChartClick}
            />
          </div>
          :
          <KoFlex wrap="wrap" gap="small" className={styles.emptySection}>
            <KoEmpty subText="" icon={'EmptyTwoTone'} title="You have no assigned Timesheet" />
          </KoFlex>
        }
        {selectedCategory && (
          <div className={styles.projectChartChildWrapper}>
            <div className={styles.projectChartChild}>
              <KoCharts option={getPieChartOption()}  />
            </div>
            <div className={styles.projectChartChild}>
              <KoCharts option={getPieChartDayOption()}  />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
